import { render, staticRenderFns } from "./DashboardStoreSelect.vue?vue&type=template&id=cafbd474&scoped=true&"
import script from "./DashboardStoreSelect.vue?vue&type=script&lang=js&"
export * from "./DashboardStoreSelect.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStoreSelect.vue?vue&type=style&index=0&id=cafbd474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafbd474",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
